import React from 'react';
import { MessageCircleIcon, MailIcon, FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-zinc-950 border-t border-zinc-800 py-12 px-4" data-id="element-93">
      <div className="max-w-7xl mx-auto" data-id="element-94">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-95">
          <div data-id="element-96">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rDDbVYSSWnpEBZ6FKUoh2o/LOGO_BODENOR.png" alt="Bodenor" className="h-12 mb-4" data-id="element-97" />
            <p className="text-gray-400 text-sm" data-id="element-98">
              Bodegas Industriales de Nororiente
            </p>
          </div>

          <div data-id="element-99">
            <h4 className="text-white font-bold mb-4" data-id="element-100">Contacto</h4>
            <div className="space-y-2 text-sm" data-id="element-101">
              <a href="https://wa.me/50245607548" className="flex items-center gap-2 text-gray-400 hover:text-yellow-400 transition-colors" data-id="element-102">
                <MessageCircleIcon size={16} data-id="element-103" />
                +502 4560 7548
              </a>
              <a href="mailto:Zacaparenta123@gmail.com" className="flex items-center gap-2 text-gray-400 hover:text-yellow-400 transition-colors" data-id="element-104">
                <MailIcon size={16} data-id="element-105" />
                Zacaparenta123@gmail.com
              </a>
            </div>
          </div>

          <div data-id="element-106">
            <h4 className="text-white font-bold mb-4" data-id="element-107">Síguenos</h4>
            <div className="flex gap-4" data-id="element-108">
              <a href="https://www.facebook.com/profile.php?id=61584253739534" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-400 transition-colors" aria-label="Facebook" data-id="element-109">
                <FacebookIcon size={20} data-id="element-110" />
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors" aria-label="Instagram" data-id="element-111">
                <InstagramIcon size={20} data-id="element-112" />
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors" aria-label="LinkedIn" data-id="element-113">
                <LinkedinIcon size={20} data-id="element-114" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-8 text-center text-sm text-gray-500" data-id="element-115">
          <p data-id="element-116">
            &copy; {new Date().getFullYear()} Bodenor. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}